import BccRwdSoftLinks from 'components/Bcc/BccRwdSoftLinks/BccRwdSoftLinks';

export default BccRwdSoftLinks;
